import React from "react";
import * as Survey from "survey-react";
import "survey-react/modern.css";
import { Redirect, Link } from "react-router-dom";
import surveyData from "./surveyData.js";
import { getWordCount, WordCountMinValidator } from "./helpers.js";
import "./survey.css";
import logo from "../../assets/logos/logo.png";



const SurveyPage = ({ completed, setSurveyResult, setCompleted, primaryColor, customerID }) => {

    var defaultThemeColors = Survey.StylesManager.ThemeColors["modern"];

    defaultThemeColors["$main-color"] = primaryColor;
    defaultThemeColors["$text-color"] = "black";
    defaultThemeColors["$main-hover-color"] = "black";
    defaultThemeColors["$header-background-color"] = "#666";
    defaultThemeColors["$answer-background-color"] = "transparent";
    defaultThemeColors["$error-background-color"] = "#E88484";

    Survey.StylesManager.applyTheme("modern");
    Survey.FunctionFactory.Instance.register("WordCountMinValidator", WordCountMinValidator);


    Survey.surveyLocalization.locales["de"].requiredError = "Bitte beantworte diese Frage.";
    const survey = new Survey.Model(surveyData);
    survey.logoPosition = "left";
    survey.showProgressBar = 'bottom';
    survey.showCompletedPage = false;

    let big5Text = localStorage.getItem("professional_challenge");


    survey.onAfterRenderQuestion.add(function (survey, options) {
        if (options.question.getType() !== "comment") return;
        const textArea = options.htmlElement.getElementsByTagName('textarea')[0];
        if (big5Text) textArea.textContent = big5Text;

        const div = document.createElement("div");
        div.classList.add("wordCount");
        div.style.float = "right";
        textArea.parentNode.insertBefore(div, textArea.nextSibling);
        const changingHandler = function () {
            const currentWords = getWordCount(textArea.value);
            div.innerHTML = "Words: " + (currentWords - 1) + "/" + 100;
        };
        changingHandler();
        textArea.addEventListener("input", changingHandler);
    });



    const handleComplete = (result) => {
        localStorage.setItem("professional_challenge", result.data.big5Text);
        setSurveyResult(result.data);
        setCompleted(true);
    };

    if (completed) {
        return (
            <Redirect to="/report" />
        )
    }

    return (
        <div className="survey-container">
            <div className="survey-header">
                <Link className='test' to="/">
                    <img src={logo} className="survey-header-img" alt="logo" />
                </Link>
            </div>

            <div className="survey-body">
                <Survey.Survey model={survey} onComplete={handleComplete} />
            </div>
        </div>
    );
}

export default SurveyPage;